import {ReactNode, useEffect} from 'react';
import {createRoot, Root} from 'react-dom/client';
import {Toast} from '../design-system/atoms/Toast/Toast';
import {TOAST_FADE_IN_MS, TOAST_WRAPPER_ID} from './constants';

let toastTimerId: NodeJS.Timeout | null = null;
let rootContainer: Root | null;

export function showToast({
  message,
  isMobile,
  delayMs = 2000,
}: {
  message: string | ReactNode;
  isMobile: boolean;
  delayMs?: number;
}) {
  if (toastTimerId) {
    clearTimeout(toastTimerId);
  }
  // 현재 떠있는 토스트가 있다면 애니메이션 없이 즉시 DOM에서 제거합니다.
  removeToast();

  const container = createToastWrapperDiv();
  rootContainer = createRoot(container);
  rootContainer.render(
    <ToastContainer
      callback={() => {
        toastTimerId = setTimeout(() => {
          const toastContainer = document.getElementById(TOAST_WRAPPER_ID);
          if (toastContainer) {
            toastContainer.style.transition = 'opacity 0.3s';
            toastContainer.style.opacity = '0';
            // transition이 끝나기 전에 toastContainer가 제거되었다면, 삭제 로직을 수행하지 않습니다.
            toastContainer.ontransitionend = () => {
              removeToast();
            };
          }
        }, delayMs + TOAST_FADE_IN_MS);
      }}
      message={message}
      isMobile={isMobile}
    />
  );
}

function ToastContainer({
  callback,
  message,
  isMobile,
}: {
  callback: VoidFunction;
  message: string | ReactNode;
  isMobile: boolean;
}) {
  useEffect(() => {
    callback();
  }, [callback]);

  return (
    <div className="pointer-events-none z-100 flex h-full w-full animate-fade-in flex-row justify-center bg-transparent">
      <div className="mb-90pxr self-end">
        <Toast message={message} isMobile={isMobile} />
      </div>
    </div>
  );
}

function createToastWrapperDiv() {
  const container = document.createElement('div');
  container.id = TOAST_WRAPPER_ID;
  container.style.cssText =
    'position: fixed; top: 0px; left: 0px; z-index : 200; width: 100%; height: 100%; pointer-events: none; height: fill-available; height: -webkit-fill-available';
  document.body.appendChild(container);
  return container;
}

export function removeToast() {
  const toastContainer = document.getElementById(TOAST_WRAPPER_ID);
  if (toastContainer) {
    if (rootContainer) {
      rootContainer.unmount();
      rootContainer = null;
    }
    toastContainer.parentNode?.removeChild(toastContainer);
  }
}
